import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=53fb65e3&scoped=true"
import script from "./GridView.vue?vue&type=script&lang=js"
export * from "./GridView.vue?vue&type=script&lang=js"
import style0 from "./GridView.vue?vue&type=style&index=0&id=53fb65e3&lang=scss&scoped=true"
import style1 from "./GridView.vue?vue&type=style&index=1&id=53fb65e3&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb65e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53fb65e3')) {
      api.createRecord('53fb65e3', component.options)
    } else {
      api.reload('53fb65e3', component.options)
    }
    module.hot.accept("./GridView.vue?vue&type=template&id=53fb65e3&scoped=true", function () {
      api.rerender('53fb65e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/GridView.vue"
export default component.exports